var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prize"},[_c('router-link',{attrs:{"to":_vm.advertisingInfo.href || ''}},[_c('img',{attrs:{"src":_vm.advertisingInfo.img}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }